"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lazyGettext = _interopRequireDefault(require("js-utils/lazy-gettext"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Button = _interopRequireDefault(require("eventbrite_design_system/button/Button"));

var _Icon = _interopRequireDefault(require("eventbrite_design_system/icon/Icon"));

var _constants = require("eventbrite_design_system/button/constants");

var _constants2 = require("./constants");

var _FacebookLoginComponent = _interopRequireDefault(require("./FacebookLoginComponent"));

require("./facebookLoginButton.scss");

var _LogoFacebookWhite = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/LogoFacebookWhite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FacebookLogo = function FacebookLogo() {
  return _react.default.createElement("div", {
    className: "facebook-button__logo eds-g-cell"
  }, _react.default.createElement("div", {
    className: "eds-align--left"
  }, _react.default.createElement(_Icon.default, {
    type: _react.default.createElement(_LogoFacebookWhite.default, null),
    size: "small"
  })));
};

var ContinueWithFacebookButton = function ContinueWithFacebookButton(_ref) {
  var accessToken = _ref.accessToken,
      picture = _ref.picture,
      firstName = _ref.firstName,
      handleOnClick = _ref.handleOnClick;
  var component = null;
  var dataAutomation = 'facebook-login-button';

  if (accessToken) {
    component = _react.default.createElement("div", {
      className: "facebook-button-container"
    }, _react.default.createElement(_Button.default, {
      "data-automation": dataAutomation,
      type: "button",
      style: _constants.STYLE_FILL,
      size: _constants.SIZE_BLOCK,
      onClick: handleOnClick
    }, _react.default.createElement("div", {
      className: "eds-g-grid"
    }, _react.default.createElement("div", {
      className: "eds-g-group eds-g-group--full-width"
    }, _react.default.createElement("div", {
      className: "facebook-button__content eds-align--center"
    }, _react.default.createElement(FacebookLogo, null), _react.default.createElement("div", {
      className: "facebook-button__text eds-g-cell"
    }, (0, _lazyGettext.default)('Continue as %(firstName)s ', {
      firstName: firstName
    })), _react.default.createElement("div", {
      className: "eds-g-cell facebook-button__image-wrapper"
    }, _react.default.createElement("div", {
      className: "eds-align--center"
    }, _react.default.createElement("img", {
      className: "facebook-button__image",
      src: picture.data.url,
      alt: picture
    }))))))));
  } else {
    component = _react.default.createElement("div", {
      className: "facebook-button-container"
    }, _react.default.createElement(_Button.default, {
      "data-automation": dataAutomation,
      type: "button",
      style: _constants.STYLE_FILL,
      size: _constants.SIZE_BLOCK,
      onClick: handleOnClick
    }, _react.default.createElement("div", {
      className: "eds-g-grid eds-g-group eds-g-group--full-width"
    }, _react.default.createElement("div", {
      className: "facebook-button__content eds-align--center"
    }, _react.default.createElement(FacebookLogo, null), _react.default.createElement("div", {
      className: "facebook-button__text eds-g-cell eds-l-pad-hor-1"
    }, (0, _lazyGettext.default)('Continue with Facebook'))))));
  }

  return component;
};

var FacebookLoginButton =
/*#__PURE__*/
function (_Component) {
  _inherits(FacebookLoginButton, _Component);

  function FacebookLoginButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FacebookLoginButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FacebookLoginButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      transitToLogin: false
    });

    _defineProperty(_assertThisInitialized(_this), "_onFacebookUserNotConnected", function (status) {
      var onSocialConnectNotAuthorized = _this.props.onSocialConnectNotAuthorized;

      if (_this.state.transitToLogin && (0, _includes.default)(['unknown', 'not_authorized'], status)) {
        if (onSocialConnectNotAuthorized) {
          onSocialConnectNotAuthorized({
            sourceProvider: _constants2.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
            status: status
          });
        }
      }

      _this.setState({
        status: status,
        transitToLogin: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onFacebookResponse", function (response) {
      var onSocialConnectVerified = _this.props.onSocialConnectVerified;
      var transitToLogin = _this.state.transitToLogin;
      var accessToken = response.accessToken,
          email = response.email,
          firstName = response.first_name,
          lastName = response.last_name;

      if (transitToLogin) {
        if (onSocialConnectVerified) {
          onSocialConnectVerified({
            accessToken: accessToken,
            email: email,
            sourceProvider: _constants2.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
            firstName: firstName,
            lastName: lastName
          });
        }
      } else {
        _this.setState(_objectSpread({}, response, {
          transitToLogin: true
        }));
      }
    });

    return _this;
  }

  _createClass(FacebookLoginButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appId = _this$props.appId,
          version = _this$props.version,
          scope = _this$props.scope,
          fields = _this$props.fields,
          reRequestPermissions = _this$props.reRequestPermissions,
          handleOnLoadComplete = _this$props.handleOnLoadComplete,
          onButtonClick = _this$props.onClick;

      var _this$state = this.state,
          accessToken = _this$state.accessToken,
          picture = _this$state.picture,
          firstName = _this$state.first_name,
          state = _objectWithoutProperties(_this$state, ["accessToken", "picture", "first_name"]);

      var renderButton = function renderButton(_ref2) {
        var onClick = _ref2.onClick;

        var _handleOnClick = function _handleOnClick() {
          if (onButtonClick) {
            onButtonClick(state);
          }

          onClick();
        };

        return _react.default.createElement(ContinueWithFacebookButton, {
          accessToken: accessToken,
          picture: picture,
          firstName: firstName,
          handleOnClick: _handleOnClick
        });
      };

      return _react.default.createElement(_FacebookLoginComponent.default, {
        appId: appId,
        handleOnResponse: this._onFacebookResponse,
        handleOnLoadComplete: handleOnLoadComplete,
        handleOnNotConnected: this._onFacebookUserNotConnected,
        renderProps: renderButton,
        version: version,
        autoLogin: true,
        scope: scope,
        fields: fields,
        cookie: true,
        reRequestPermissions: reRequestPermissions
      });
    }
  }]);

  return FacebookLoginButton;
}(_react.Component);

exports.default = FacebookLoginButton;

_defineProperty(FacebookLoginButton, "propTypes", {
  appId: _propTypes.default.string,
  version: _propTypes.default.string,
  scope: _propTypes.default.string,
  fields: _propTypes.default.string,
  onSocialConnectVerified: _propTypes.default.func,
  onSocialConnectNotAuthorized: _propTypes.default.func,
  onLoadComplete: _propTypes.default.func,
  onClick: _propTypes.default.func
});

_defineProperty(FacebookLoginButton, "defaultProps", {
  fields: 'name,email,picture,first_name,last_name'
});
//# sourceMappingURL=FacebookLoginButton.js.map